/* [PREVIEW] Mount add-on for Paige: keep each mount line (_parent) in step with its
   Stall Monitor line (_mount_group). Qty follows the monitor; removing the monitor removes the mount. */
(function () {
  'use strict';
  var busy = false;
  var origFetch = window.fetch;
  if (!origFetch) return;

  /* [PREVIEW] Old-variant guard: any add of the legacy Stall Monitor variants (HCB/HCA combo SKUs),
     from any path (buy box add-on, quick add, product forms, native forms), is rewritten to
     Base (HSM-BLK-01) + linked mount line. Map comes from window.hzSplit (layout/theme.liquid). */
  var CFG = window.hzSplit || null;
  function key() { return 'hsm-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function rewriteItems(items) {
    if (!CFG) return { items: items, changed: false };
    var out = [], changed = false;
    items.forEach(function (it) {
      var m = CFG.map[String(it.id)];
      if (!m) { out.push(it); return; }
      changed = true;
      var q = Number(it.quantity) || 1, g = key();
      var props = Object.assign({}, it.properties || {}); delete props._mount_sku;
      props._mount_group = g;
      out.push({ id: Number(CFG.base), quantity: q, properties: props });
      out.push({ id: Number(m.mount), quantity: q, properties: { _parent: g, _mount_sku: m.sku } });
    });
    return { items: out, changed: changed };
  }
  function bodyToJson(body) {
    // returns {json} for FormData / URLSearchParams / JSON string bodies, or null
    try {
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') return JSON.parse(body);
        body = new URLSearchParams(body);
      }
      if (body && typeof body.forEach === 'function' && (typeof FormData !== 'undefined' && body instanceof FormData || body instanceof URLSearchParams)) {
        var o = {}, props = {}, items = {};
        body.forEach(function (v, k) {
          var pm = k.match(/^properties\[(.+)\]$/), im = k.match(/^items\[(\d+)\]\[(id|quantity)\]$/), ip = k.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
          if (pm) props[pm[1]] = v;
          else if (im) { (items[im[1]] = items[im[1]] || {})[im[2]] = v; }
          else if (ip) { var it = (items[ip[1]] = items[ip[1]] || {}); (it.properties = it.properties || {})[ip[2]] = v; }
          else if (typeof v === 'string') o[k] = v;
        });
        var arr = Object.keys(items).sort(function (a, b) { return a - b; }).map(function (i) { return items[i]; });
        if (o.id) { arr.unshift({ id: o.id, quantity: o.quantity || 1, properties: Object.keys(props).length ? props : undefined }); delete o.id; delete o.quantity; }
        o.items = arr; return o;
      }
    } catch (e) {}
    return null;
  }
  function rewriteBody(body) {
    var j = bodyToJson(body);
    if (!j) return null;
    var items = j.items || (j.id ? [{ id: j.id, quantity: j.quantity || 1, properties: j.properties }] : []);
    var r = rewriteItems(items);
    if (!r.changed) return null;
    delete j.id; delete j.quantity; delete j.properties;
    j.items = r.items;
    return JSON.stringify(j);
  }
  window.hzRewriteCartBody = rewriteBody;

  function plan(cart) {
    var groups = {}, updates = {}, n = 0;
    cart.items.forEach(function (it) {
      var g = it.properties && it.properties._mount_group;
      if (g) groups[g] = (groups[g] || 0) + it.quantity;
    });
    cart.items.forEach(function (it) {
      var p = it.properties && it.properties._parent;
      if (!p) return;
      var want = groups[p] || 0;
      if (it.quantity !== want) { updates[it.key] = want; n++; }
    });
    return n ? updates : null;
  }

  function refreshUI() {
    if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    origFetch.call(window, window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ni = doc.querySelector('#CartDrawer'), ci = drawer.querySelector('#CartDrawer');
        if (ni && ci) ci.innerHTML = ni.innerHTML;
        var empty = !!doc.querySelector('.drawer__inner.is-empty');
        drawer.classList.toggle('is-empty', empty);
      }).catch(function () {});
    origFetch.call(window, '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-hz-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.classList.toggle('is-empty', c.item_count === 0); });
    }).catch(function () {});
  }

  function sync() {
    if (busy) return Promise.resolve();
    busy = true;
    return origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var u = plan(cart);
        if (!u) return;
        return origFetch.call(window, '/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: u })
        }).then(refreshUI);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Run after any theme cart change (qty stepper, remove button, drawer edits).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(url) && init && init.body) {
      var nb = rewriteBody(init.body);
      if (nb) {
        var h = {}; try { new Headers(init.headers || {}).forEach(function (v, k) { h[k] = v; }); } catch (e) {}
        h['content-type'] = 'application/json'; if (!h.accept) h.accept = 'application/json';
        if (h['x-requested-with'] === undefined) h['x-requested-with'] = 'XMLHttpRequest';
        init = Object.assign({}, init, { body: nb, headers: h });
        var u2 = url.replace(/\/cart\/add(\.json)?(?=\?|$)/, '/cart/add.js');
        return origFetch.call(this, u2, init);
      }
    }
    var res = origFetch.apply(this, arguments);
    if (/\/cart\/(change|update)(\.js)?/.test(url)) {
      res.then(function () { setTimeout(sync, 50); }).catch(function () {});
    }
    return res;
  };
  window.hzMountSync = sync;
  // Native (non-JS) form posts of legacy variants: intercept and post the rewritten lines.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
    var nb = rewriteBody(new FormData(f));
    if (!nb || e.defaultPrevented) return;
    e.preventDefault();
    origFetch.call(window, '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: nb })
      .then(function () { window.location = '/cart'; });
  }, true);
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
})();
